import React, { Component } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { translate } from "react-i18next"
import uniqid from "uniqid"

const QuestionDiv = styled.div`
  margin-left: 5px;
`
class CustomReportReviewQuestion extends Component {
  state = {
    checked: false
  }
  handleCheckboxClick = (e) => {
    if (e.target.value === "false"){
      if (typeof this.props.addSelectedQuestions === 'function') {
        this.props.addSelectedQuestions(this.props.question);
      }
    } else {
      if (typeof this.props.removeSelectedQuestions === 'function') {
        this.props.removeSelectedQuestions(this.props.question);
      }
    }
  }

  render() {
    const { question, t } = this.props
    const translatedText = t(question.textTranslationIdentifier)

    // Creating a unique identitfier for the checkbox to make sure we don't have clashes.
    const checkboxId = `chk_${uniqid()}_${question.questionId}`
    return (
      <QuestionDiv>
        <div className="row">
          <div className="col-lg-11 col-md-11">
            {translatedText.length > 0 && <span>{translatedText}</span>}
            {translatedText.length < 1 && (
              <span>
                <i>&lt;No Question Text&gt;</i>
              </span>
            )}
          </div>
          <div className="col-lg-1 col-md-1" style={{paddingLeft: "8px"}}>
            <input
                type="checkbox"
                id={checkboxId}
                checked={question.checked}
                className="filled-in"
                onChange={this.handleCheckboxClick}
                value={question.checked}
              />
              <label htmlFor={checkboxId}>&nbsp;</label>
          </div>
        </div>
      </QuestionDiv>
    )
  }
}

CustomReportReviewQuestion.propTypes = {
  t: PropTypes.func.isRequired,
  question: PropTypes.shape({
    questionId: PropTypes.number.isRequired,
    clientWorkflowStepId: PropTypes.number.isRequired,
    textTranslationIdentifier: PropTypes.string.isRequired,
  }).isRequired,
  addSelectedQuestions: PropTypes.func,
  removeSelectedQuestions: PropTypes.func
}
export default translate()(CustomReportReviewQuestion)



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/QuestionSelection/CustomReportReviewQuestion.jsx